// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Applicant-form-container {
  background: url("https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1600&q=80")
    no-repeat center center/cover;
  min-height: 100vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "IBM Plex Sans", sans-serif;
}

.Applicant-form-container h1 {
  margin-bottom: 2rem;
  color: white;
  text-shadow: 1px 1px 4px black;
}

form {
  background-color: rgba(255, 255, 255, 0.95);
  padding: 2rem;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

input,
textarea {
  padding: 0.75rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
}

textarea {
  min-height: 100px;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #0056b3;
}

.applicant-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
}

.applicant-container img {
  width: 150px;
  margin-bottom: 1rem;
}

.applicant-container h1 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color: #222;
}

.form-embed-container {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 0;
}

.applicant-header {
  text-align: center;
  margin-bottom: 2rem;
}

.ace-logo {
  width: 200px;
  margin-bottom: 1rem;
}

.apply-title {
  font-size: 2rem;
  font-weight: bold;
}

.form-wrapper {
  width: 100%;
  overflow-x: hidden;
}

iframe {
  width: 100%;
  border: none;
  min-height: 2100px; /* Adjust if needed */
}

/* Responsive Media Queries */
@media (max-width: 1024px) {
  body,
  .container {
    padding: 1rem;
    font-size: 1rem;
  }
  img,
  video {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 600px) {
  .container,
  .card,
  .section,
  .content {
    flex-direction: column !important;
    width: 100% !important;
    font-size: 0.9rem !important;
    padding: 0.5rem !important;
  }

  h1,
  h2,
  h3 {
    font-size: 1.2rem !important;
  }

  nav,
  header,
  footer {
    flex-direction: column;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ApplicantApply.css"],"names":[],"mappings":"AAAA;EACE;iCAC+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA,6BAA6B;AAC7B;EACE;;IAEE,aAAa;IACb,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;;;;IAIE,iCAAiC;IACjC,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;;;IAGE,4BAA4B;EAC9B;;EAEA;;;IAGE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".Applicant-form-container {\n  background: url(\"https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1600&q=80\")\n    no-repeat center center/cover;\n  min-height: 100vh;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: \"IBM Plex Sans\", sans-serif;\n}\n\n.Applicant-form-container h1 {\n  margin-bottom: 2rem;\n  color: white;\n  text-shadow: 1px 1px 4px black;\n}\n\nform {\n  background-color: rgba(255, 255, 255, 0.95);\n  padding: 2rem;\n  border-radius: 12px;\n  max-width: 600px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\ninput,\ntextarea {\n  padding: 0.75rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n}\n\ntextarea {\n  min-height: 100px;\n}\n\nbutton {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 1rem;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\n.applicant-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem;\n  text-align: center;\n}\n\n.applicant-container img {\n  width: 150px;\n  margin-bottom: 1rem;\n}\n\n.applicant-container h1 {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 2rem;\n  color: #222;\n}\n\n.form-embed-container {\n  position: relative;\n  overflow: hidden;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 0;\n}\n\n.applicant-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.ace-logo {\n  width: 200px;\n  margin-bottom: 1rem;\n}\n\n.apply-title {\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.form-wrapper {\n  width: 100%;\n  overflow-x: hidden;\n}\n\niframe {\n  width: 100%;\n  border: none;\n  min-height: 2100px; /* Adjust if needed */\n}\n\n/* Responsive Media Queries */\n@media (max-width: 1024px) {\n  body,\n  .container {\n    padding: 1rem;\n    font-size: 1rem;\n  }\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 600px) {\n  .container,\n  .card,\n  .section,\n  .content {\n    flex-direction: column !important;\n    width: 100% !important;\n    font-size: 0.9rem !important;\n    padding: 0.5rem !important;\n  }\n\n  h1,\n  h2,\n  h3 {\n    font-size: 1.2rem !important;\n  }\n\n  nav,\n  header,\n  footer {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
